
export function IconButton({ children, ...rest }) {
    return (
        <button className="cursor-pointer flex-center border-none nv-iconButton" {...rest}>{children}</button>
    )
}